import request from '../../axios';

interface IProps {
  pageParam: number;
  stateId: string;
}

export const getListContractedStore = async ({pageParam, stateId}: IProps) => {
  const {data}: {data: IContractedStoreResponse} = await request.get(
    `/api/v2/store/list-contracted-store?state=165`,
    {
      params: {
        page: pageParam,
        state: stateId,
      },
    },
  );

  return data;
};
